import { View } from "binder"
import { GridLocationSpecifierViewModel } from "./gridLocationSpecifier-viewModel"

export class GridLocationSpecifierView extends View<GridLocationSpecifierViewModel>{
    GetViewUniqueId(): string {
        return "V-18D34E32-495A-41DB-92C9-8D0834AD9FE6"
    }
    loadHtml(): string {
        let element = require('./gridLocationSpecifier.html').default;
        let style = require('./gridLocationSpecifier.less');
        return element;
    }
    constructor() {
       super();
    }

    public set column(v: number) { 
        this._column = v; 
        this.updateColumnAndRow();
    } public get column(): number { return this._column;} private _column: number;
    public set row(v: number) { 
        this._row = v; 
        this.updateColumnAndRow();
    } public get row(): number { return this._row;} private _row: number;
    public set isOver(v: boolean) { this._isOver = v; } public get isOver(): boolean { return this._isOver;} private _isOver: boolean;

    public override onRenderCompleted() {
        this.updateColumnAndRow();
    }

    private updateColumnAndRow(){
        if(this.firstlevelElement){
            let h = <HTMLElement>this.firstlevelElement;
            h.style['grid-row-start'] = (this.row ?? 1).toString();
            h.style['grid-column-start'] = (this.column ?? 1).toString();
        }
    }

    public override onDataContextSet() {
        this.dataContext.IsMourseOver = (x,y)=>this.IsMouseOver(x,y);    
    }
    IsMouseOver(clientX,clientY): boolean {
        let e = <HTMLElement>this.firstlevelElement;
        if(e){
            let rect = e.getBoundingClientRect();
            let left =rect.left 
            let width = rect.width ;
            let top = rect.top ;
            let height = rect.height ;
            if(left<clientX && clientX<(left+width) && top<clientY && clientY<(top+height)){
                return true;
            }
        }
        return false;
    }


}
